"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icon = exports.p = exports.h1 = exports.heading = exports.header = exports.popup = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popup = exports.popup = (0, _glamor.css)({
  width: "802px",
  margin: "auto",
  // border: '1px solid #333',
  padding: (0, _css.unitRem)(2.166) + " " + (0, _css.unitRem)(3.33) + " " + (0, _css.unitRem)(2.58),
  paddingBottom: (0, _css.unitRem)(2.166),

  background: _css.pallets.grayMid_popups
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  // fontSize: '0.9em !important',
  // padding: '30px',
  width: "100%!important",
  padding: (0, _css.unitRem)(2.166) + " " + (0, _css.unitRem)(1.33) + " " + (0, _css.unitRem)(2.58),
  paddingBottom: (0, _css.unitRem)(2.166)
}), (0, _css.minWidth)(_css.breakpoints.medium)({
  width: "" + (_css.sizes.innerMaxWidthTighter + 2),
  paddingBottom: (0, _css.unitRem)(2.166)
}));

var header = exports.header = (0, _glamor.css)({
  color: _css.pallets.white,
  marginBottom: (0, _css.unitRem)(2),
  textAlign: "center",
  display: "flex",
  alignItems: "center"
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  textAlign: "left"
}));

var heading = exports.heading = (0, _glamor.css)({
  display: "block",
  position: "relative",
  paddingLeft: 0,
  paddingTop: 0
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline-block",
  paddingLeft: "1.5rem"
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({}));

var h1 = exports.h1 = (0, _glamor.css)({
  fontWeight: 700,
  fontSize: (0, _css.unitRem)(1.25),
  letterSpacing: "-2px",

  marginBottom: (0, _css.unitRem)(1.25)
  // textAlign: 'center',
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.875,
    mediumLarge: [1.4, 1.875]
  }
}), (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  // textAlign: 'left',
  marginBottom: (0, _css.unitRem)(0.5)
}));

var p = exports.p = (0, _glamor.css)({
  color: _css.pallets.gray_text,
  fontSize: (0, _css.unitRem)(0.75),
  // textAlign: 'center',
  fontWeight: 400
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  // textAlign: 'left',
}));
var title = (0, _glamor.css)(_fonts.H5, {
  fontSize: "1.875rem!important",
  letterSpacing: "-1.5px!important",
  marginTop: 0
  // textAlign: 'center',
});

var description = (0, _glamor.css)(_fonts.p3, {
  color: _css.pallets.gray_text
});
var textInput = (0, _glamor.css)({
  paddingTop: (0, _css.unitRem)(1)
});

var foot = function foot(end) {
  return (0, _glamor.css)({
    display: "block",

    marginTop: (0, _css.unitRem)(1)
  }, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
    display: "flex",
    justifyContent: end ? "end" : "space-between",
    alignItems: "center",
    marginTop: (0, _css.unitRem)(2)
  }));
};

var submitButton = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2),
  textAlign: "center",
  display: "block",
  "& button": {
    paddingLeft: (0, _css.unitRem)(2.5),
    paddingRight: (0, _css.unitRem)(2.5),
    fontSize: (0, _css.unitRem)(0.625)
  },
  "& a": {
    paddingLeft: (0, _css.unitRem)(2.5),
    paddingRight: (0, _css.unitRem)(2.5),
    fontSize: (0, _css.unitRem)(0.625)
  }
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  display: "inline",
  marginTop: "unset",
  textAlign: "left"
}), (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  "& button": {
    fontSize: "1rem!important"
  },
  "& a": {
    fontSize: "1rem!important"
  }
}));

var ol = (0, _glamor.css)({
  counterReset: "item",
  paddingLeft: (0, _css.unitRem)(0.5)
});

var li = (0, _glamor.css)({
  color: _css.pallets.gray_text,
  lineHeight: (0, _css.unitRem)(1),
  listStyle: "none",
  fontWeight: 500,
  paddingTop: (0, _css.unitRem)(1),

  ":before": {
    position: "absolute",
    color: _css.pallets.gray_text,
    content: 'counters(item, ".")". "',
    counterIncrement: "item",
    left: "0"
  }
});

var icon = exports.icon = (0, _glamor.css)({
  width: "auto",
  height: (0, _css.unitRem)(2.66),
  display: "none"
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline-block"
}));

var checkBox = (0, _glamor.css)({
  display: "block",
  marginTop: (0, _css.unitRem)(1)
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline",
  marginTop: "unset"
}));

var formFields = function formFields(small) {
  return (0, _glamor.css)({
    display: small ? "block" : "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  });
};

var field = (0, _glamor.css)({
  flexBasis: "48.85%",
  flexShrink: 0,

  paddingTop: (0, _css.unitRem)(1)
});

var link_css = (0, _glamor.css)({
  fontSize: "1rem",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  textAlign: "left",
  textDecoration: "none",
  color: "#2b98f0"
});

var cont = (0, _glamor.css)({
  display: "flex"
});

var SubmitArtPopup = function SubmitArtPopup(props) {
  return _react2.default.createElement(
    _Form2.default,
    {
      className: popup,
      error: props.error,
      message: props.message,
      onSubmit: props.onSubmit,
      onChildRef: props.onChildRef
    },
    _react2.default.createElement(
      "div",
      { className: header },
      _react2.default.createElement("img", { src: props.icon, alt: "", className: icon }),
      _react2.default.createElement(
        "div",
        { className: heading },
        _react2.default.createElement(
          "h1",
          { className: title },
          "Submit Artwork"
        )
      )
    ),
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: textInput },
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          label: "Artwork Url",
          disabled: props.submitting,
          autoComplete: true,
          autoFocus: true,
          simpleError: true
        }, props.artworkUrlInputProps))
      ),
      _react2.default.createElement(
        "div",
        {
          className: formFields(
          // eslint-disable-next-line
          props.containerQuery && props.containerQuery.small)
        },
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          className: field,
          label: "Name",
          type: "text",
          disabled: props.submitting,
          autoComplete: true,
          simpleError: true
        }, props.nameInputProps)),
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          className: field,
          label: "Email",
          type: "email",
          name: "email",
          disabled: true,
          autoComplete: true,
          simpleError: true
        }, props.emailInputProps)),
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          className: field,
          label: "Title",
          type: "text",
          disabled: props.submitting,
          autoComplete: true,
          simpleError: true
        }, props.titleInputProps)),
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          className: field,
          label: "Quixel Tools Used",
          type: "text",
          disabled: props.submitting,
          autoComplete: true,
          simpleError: true
        }, props.toolsInputProps)),
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          className: field,
          label: "Homepage",
          disabled: props.submitting,
          autoComplete: true,
          simpleError: true
        }, props.homeUrlInputProps)),
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          className: field,
          label: "Artstation",
          disabled: props.submitting,
          autoComplete: true,
          simpleError: true
        }, props.artStationUrlInputProps))
      ),
      _react2.default.createElement(
        "div",
        { className: textInput },
        _react2.default.createElement(
          "ol",
          { className: ol },
          props.terms.map(function (term, i) {
            return _react2.default.createElement(
              "li",
              { className: li },
              _react2.default.createElement(
                "p",
                { className: (0, _glamor.css)({ marginLeft: "2px" }) },
                term
              )
            );
          })
        )
      ),
      _react2.default.createElement(
        "div",
        { className: foot(!props.shouldUpdateEula) },
        props.shouldUpdateEula && _react2.default.createElement(
          "div",
          { className: cont },
          _react2.default.createElement(_Checkbox2.default, (0, _extends3.default)({
            className: checkBox,
            disabled: props.submitting,
            label: "",
            simpleError: true
          }, props.acceptTos, {
            onChange: function onChange(e) {
              props.onChangeHandler();
              props.acceptTos.onChange(e);
            }
          })),
          _react2.default.createElement(
            "span",
            null,
            "I agree to the\xA0",
            _react2.default.createElement(
              _reactRouter.Link,
              { className: link_css, target: "_blank", to: "/terms" },
              "Content License Agreement."
            )
          )
        ),
        props.message ? _react2.default.createElement(_Button2.default, {
          small: true,
          type: "button",
          className: submitButton,
          mode: "secondary",
          onClick: props.onOKClick,
          label: "Ok",
          disabled: !props.termsChecked
        }) : _react2.default.createElement(_Button2.default, {
          small: true,
          type: "submit",
          className: submitButton,
          mode: "secondary",
          loading: props.submitting,
          label: "Send Request",
          disabled: !props.termsChecked
        })
      )
    )
  );
};

exports.default = SubmitArtPopup;


//////////////////
// WEBPACK FOOTER
// ./src/pages/SubmitArtwork/SubmitArtForum.jsx
// module id = 2966
// module chunks = 0